module.exports = __webpack_public_path__ + "img/compass-icon-on.91546a37.svg";